<template>
  <div class="applicantInfo">
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle"><p>电信业务种类</p></div>
      <div class="formItemRightMain">
        <el-input
          v-model="form.telecommunication"
          placeholder="信息服务业务（仅限互联网信息服务）"
        ></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle"><p>业务覆盖范围</p></div>
      <div class="formItemRightMain">
        <el-input
          v-model="form.coverage"
          placeholder="信息服务业务（仅限互联网信息服务）：全国"
        ></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>法人类型<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-select v-model="form.corporateType" placeholder="请选择">
          <el-option
            v-for="item in corporateTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>法人名称<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input
          v-model="form.corporateName"
          placeholder="请输入企业名称或机构名称"
        ></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>统一社会信用代码<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input
          v-model="form.creditCode"
          placeholder="请输入统一社会信用代码或机构代码"
        ></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>注册资本（万元）<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input
          v-model="form.capital"
          type="number"
          placeholder="请输入数字"
        ></el-input>
        <span>人民币</span>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>注册地址<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input
          v-model="form.registeredAddress"
          placeholder="请输入企业注册地址"
        ></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>公司固定电话<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input
          v-model="form.companyLandline"
          placeholder="请输入公司固定电话"
        ></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>主要办公地址<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input
          v-model="form.officeAddress"
          placeholder="请输入企业主要办公地址"
        ></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>办公地址邮编<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input
          v-model="form.zipCode"
          placeholder="请输入主要办公地址邮编"
        ></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>公司性质<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-radio-group v-model="form.nature"
          ><el-radio label="1">民营控股</el-radio>
          <el-radio label="2">国有控股</el-radio></el-radio-group
        >
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>主营业务行业<span>*</span></p>
      </div>
      <div class="formItemRightMain formItemRightBt">
        <el-input
          disabled
          placeholder="请选择主营业务行业"
          v-model="form.mainBusiness"
        ></el-input>
        <el-button @click="dialogBusinessVisible = true">选择行业</el-button>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>公司人员规模<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-select v-model="form.staffSize" placeholder="请选择">
          <el-option
            v-for="item in staffSizeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>公司经营规模<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-select v-model="form.businessScale" placeholder="请选择">
          <el-option
            v-for="item in businessScaleList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>是否上市（含新三板）<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-radio-group v-model="form.isSale"
          ><el-radio label="1">是</el-radio>
          <el-radio label="2">否</el-radio></el-radio-group
        >
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>营业执照扫描件<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          multiple
          :limit="3"
          :on-exceed="handleExceed"
          :file-list="fileList"
        >
          <el-button size="small" type="primary"
            ><i class="el-icon-upload"></i> 上传文件</el-button
          >
          <div slot="tip" class="el-upload__tip">
            请上传jpg； jpeg； gif格式的文件
          </div>
        </el-upload>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>联系人姓名<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input
          v-model="form.contactName"
          placeholder="请输入联系人姓名"
        ></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>联系人电话<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input
          v-model="form.contactNumber"
          placeholder="请输入联系人电话"
        ></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>联系地址<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input
          v-model="form.contactAddress"
          placeholder="请输入联系地址，同时用于接收邮寄材料"
        ></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>联系人邮箱<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input
          v-model="form.staffEmail"
          placeholder="请输入联系人邮箱"
        ></el-input>
      </div>
    </div>
    <div class="formItemNext">
      <button @click="$router.push('/icpfillmaterials/implementation')">
        下一步
      </button>
    </div>
    <!-- 选择行业 -->
    <el-dialog
      class="dialogBusiness"
      title="选择主营业务行业"
      width="1000px"
      :visible.sync="dialogBusinessVisible"
    >
      <el-radio-group v-model="mainBusiness">
        <el-radio
          v-for="(item, index) in mainBusinessList"
          :key="index"
          :label="item"
          >{{ item }}</el-radio
        >
      </el-radio-group>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitDialog"
          >确认选择并提交</el-button
        >
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //表单绑定
      form: {
        telecommunication: '', //电信业务种类
        coverage: '', //业务覆盖范围
        corporateType: '', //法人类型
        corporateName: '', //法人名称
        creditCode: '', //统一社会信用代码
        capital: '', //注册资本
        registeredAddress: '', //注册地址
        companyLandline: '', //公司固定电话
        officeAddress: '', //主要办公地址
        zipCode: '', //办公地址邮编
        nature: '1', //公司性质
        mainBusiness: '', //主营业务行业
        staffSize: '', //公司人员规模
        businessScale: '', //公司经营规模
        isSale: '1', //是否上市
        businessLicense: '', //营业执照扫描件
        contactName: '', //联系人姓名
        contactNumber: '', //联系人电话
        contactAddress: '', //联系地址
        staffEmail: '' //联系人邮箱
      },
      //法人类型
      corporateTypeList: [
        {
          value: 0,
          label: '企业法人'
        },
        {
          value: 1,
          label: '社会组织法人'
        },
        {
          value: 2,
          label: '事业单位法人'
        }
      ],
      //公司人员规模
      staffSizeList: [
        {
          value: 0,
          label: '小于10人'
        },
        {
          value: 1,
          label: '大于等于10人，且小于100人'
        },
        {
          value: 2,
          label: '大于等于100人，且小于300人'
        },
        {
          value: 3,
          label: '大于等于300人，且小于2000人'
        },
        {
          value: 4,
          label: '大于等于2000人'
        }
      ],
      //公司经营规模
      businessScaleList: [
        {
          value: 0,
          label: '无营业收入'
        },
        {
          value: 1,
          label: '年收入百万级'
        },
        {
          value: 2,
          label: '年收入千万级'
        },
        {
          value: 3,
          label: '年收入过亿'
        }
      ],
      //营业执照扫描件
      fileList: [
        {
          name: 'food.jpeg',
          url:
            'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        },
        {
          name: 'food2.jpeg',
          url:
            'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        }
      ],
      //主营业务行业
      mainBusiness: '',
      mainBusinessList: [
        '金融业',
        '制造业',
        '交通运输、仓储和邮政业',
        '建筑业',
        '采矿业',
        '居民服务、修理和其他服务业',
        '国际组织',
        '住宿和餐饮业',
        '水利、环境和公共设施管理业',
        '批发零售业',
        '卫生和社会工作',
        '信息传输、软件和信息技术服务业',
        '农、林、牧、渔',
        '租赁和商务服务业',
        '公共管理、社会保障和社会组织',
        '文化、体育和娱乐业',
        '科学研究和技术服务业',
        '电力、热力、燃气及水产和供应业'
      ],
      //
      dialogBusinessVisible: false
    };
  },
  mounted() {
    this.$store.commit('qffillmaterials/changeActivedIndex', 0);
  },
  methods: {
    //提交选择行业
    submitDialog() {
      this.form.mainBusiness = this.mainBusiness;
      this.dialogBusinessVisible = false;
    },
    //取消
    cancel() {
      this.dialogBusinessVisible = false;
      this.mainBusiness = this.form.mainBusiness;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    }
  }
};
</script>

<style lang="scss">
.applicantInfo {
  width: 100%;
  background: #fff;
  padding: 4px 0;
  margin-bottom: 60px;
  .applicantInfoFormItem {
    width: 100%;
    display: flex;
    padding: 16px;
    .formItemLeftTitle {
      width: 438px;
      height: 32px;
      p {
        text-align: right;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 32px;
        padding-right: 10px;
        span {
          color: #f00;
          margin-left: 5px;
          line-height: 32px;
        }
      }
    }
    .formItemRightMain {
      flex: 1;
      display: flex;
      align-items: center;
      .el-input {
        width: 435px;
        height: 32px;
        border-radius: 4px;
        input {
          width: 100%;
          height: 100%;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 22px;
          padding: 0 12px;
          border: 1px solid rgba(0, 0, 0, 0.15);
        }
      }
      & > span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
        margin-left: 10px;
      }
      .el-button {
        width: 100px;
        height: 32px;
        padding: 0;
        border-radius: 4px;
        border: 1px solid rgba(255, 138, 1, 1);
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 138, 1, 1);
        line-height: 22px;
        background: #fff;
      }
      .upload-demo {
        width: 435px;
      }
    }
    .formItemRightBt {
      width: 435px;
      height: 32px;
      display: flex;
      flex: none;
      .el-input {
        flex: 1;
      }
      .el-button {
        width: 73px;
        margin-left: 10px;
      }
    }
  }
  .formItemNext {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;
    button {
      width: 154px;
      height: 36px;
      background: rgba(255, 138, 1, 1);
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 22px;
      border: none;
    }
  }
  .el-radio__input.is-checked .el-radio__inner {
    background: #ff8a01;
    border: 1px solid #ff8a01;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #ff8a01;
  }
  .dialogBusiness {
    .el-radio-group {
      display: flex;
      flex-wrap: wrap;
      .el-radio {
        width: 30%;
        margin-bottom: 30px;
        font-size: 14px;
      }
    }
    .dialog-footer {
      .el-button:nth-child(1) {
        background: #ff8a01;
        color: #fff;
      }
      .el-button {
        border: 1px solid #ff8a01;
        color: #ff8a01;
      }
    }
  }
}
</style>
